<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>常見問題管理</h6>
            <div>
              <button
                class="btn btn-sm btn-info mb-0 me-2"
                @click="saveOrder"
                v-if="orderChanged"
              >
                儲存排序
              </button>
              <button
                class="btn btn-sm btn-success mb-0"
                @click="$router.push('/faqs/new')"
              >
                新增問題
              </button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0 mt-3">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-secondary opacity-7"></th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      問題
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <draggable
                  v-model="faqs"
                  tag="tbody"
                  item-key="id"
                  handle=".handle"
                  @change="onDragChange"
                >
                  <template #item="{ element }">
                    <tr>
                      <td
                        class="align-middle text-center handle"
                        style="width: 50px; cursor: grab"
                      >
                        <i class="fas fa-grip-vertical text-secondary"></i>
                      </td>
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div
                            class="d-flex flex-column justify-content-center"
                          >
                            <h6 class="mb-0 text-sm">{{ element.question }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <soft-badge
                          :color="element.is_active ? 'success' : 'secondary'"
                          variant="gradient"
                          size="sm"
                        >
                          {{ element.is_active ? "啟用" : "停用" }}
                        </soft-badge>
                      </td>
                      <td class="align-middle">
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs me-3"
                          @click="$router.push(`/faqs/${element.id}/edit`)"
                        >
                          編輯
                        </a>
                        <a
                          href="javascript:;"
                          class="text-danger font-weight-bold text-xs"
                          @click="deleteFaq(element.id)"
                        >
                          刪除
                        </a>
                      </td>
                    </tr>
                  </template>
                </draggable>
              </table>
              <div
                v-if="faqs.length === 0"
                class="text-center py-4 text-secondary"
              >
                目前沒有常見問題
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import request from "@/utils/request";
import draggable from "vuedraggable";

export default {
  name: "Faqs",
  components: {
    SoftBadge,
    draggable,
  },
  data() {
    return {
      faqs: [],
      orderChanged: false,
    };
  },
  methods: {
    async fetchFaqs() {
      try {
        const response = await request.get("/api/admin/faqs");
        this.faqs = response.data.data || response.data;
        this.orderChanged = false;
      } catch (error) {
        console.error("Failed to fetch FAQs", error);
        this.$swal.fire("錯誤", "無法載入列表", "error");
      }
    },
    async deleteFaq(id) {
      if (!id) return;

      this.$swal
        .fire({
          title: "確定要刪除此問題嗎？",
          text: "此操作無法復原",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ea0606",
          confirmButtonText: "確定刪除",
          cancelButtonText: "取消",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              console.log("Deleting FAQ:", id);
              await request.delete(`/api/admin/faqs/${id}`);
              await this.fetchFaqs();
              this.$swal.fire("已刪除", "問題已成功刪除。", "success");
            } catch (error) {
              console.error("Failed to delete FAQ", error);
              this.$swal.fire(
                "錯誤",
                "刪除失敗: " + (error.response?.data?.message || error.message),
                "error"
              );
            }
          }
        });
    },
    onDragChange() {
      this.orderChanged = true;
    },
    async saveOrder() {
      try {
        const payload = {
          faqs: this.faqs.map((faq, index) => ({
            id: faq.id,
            sort_order: index,
          })),
        };
        await request.post("/api/admin/faqs/reorder", payload);
        this.orderChanged = false;
        this.$swal.fire("成功", "排序已儲存", "success");
      } catch (error) {
        console.error("Failed to save order", error);
        this.$swal.fire("錯誤", "儲存排序失敗", "error");
      }
    },
  },
  mounted() {
    this.fetchFaqs();
  },
};
</script>

<style scoped>
.handle {
  cursor: move;
}
</style>
